import { Stack } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import styles from '../newNearMiss/newNearMiss.module.css'
import { newUSerForm } from "constants/forms/user";
import FieldsGetter from "components/fields/fields";
import { useEffect, useState } from "react";
import { classNames } from "primereact/utils";
import { Button } from "antd";
import { useRecoilState, useSetRecoilState } from "recoil";
import { Confirmation } from "schemas";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import { Validate } from "utils/validation/validate";
import { AlertState } from "schemas";
import { Modal } from 'antd';
import { Button as MaterialBtn } from '@mui/material';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

export default function Enrollment() {
    const [formData, setFormData] = useState({})
    const [open, setOpen] = useState(false)
    const [confirmation, setOpenConfirm] = useRecoilState(Confirmation)
    const { fetchData, loading } = GeneralFetch()
    const setAlert = useSetRecoilState(AlertState)

    const onChange = (id, value) => setFormData((prevValues) => ({ ...prevValues, [id]: value }))

    const submit = () => setOpenConfirm({ component: "newUser", open: true, msg: `Tem certeza que deseja registar esse utilizador?` })

    useEffect(() => {
        const fetchDataAsync = async () => fetchData(
            formData,
            'newUser',
            'post',
            ''
        )

        if (confirmation.confirmed == true && confirmation?.component == "newUser") {
            const valid = Validate(formData, 'user')

            if (valid === true) {
                void fetchDataAsync().then(() => {
                    setOpenConfirm({})
                    setOpen(false)
                })
            } else setAlert(alert => ({ ...alert, type: 'warning', msg: `Por favor, preencha o campo - ${valid}` }))
        }
    }, [confirmation.confirmed])

    return (
        <div style={{ zIndex: "4000000" }} >
            <MaterialBtn
                onClick={() => setOpen(true)}
                size="medium"
                variant="contained"
                style={{
                    color: "#fff",
                    textTransform: "capitalize",
                    fontSize: "14px", letterSpacing: "1px", background: "#459FF0"
                }}
                startIcon={<PersonAddAltIcon />}
            >
                Registar Novo utilizador
            </MaterialBtn>

            <Modal
                centered
                open={open}
                width={1050}
                closable={false}
                footer={null}
            >
                <MDBox
                    mx={1}
                    mt={-5}
                    py={2}
                    px={1}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                >
                    <MDTypography variant="h6" color="white" >
                        Registo do novo utilizador
                    </MDTypography>
                </MDBox>
                <MDBox p={3}>
                    <div className={classNames(styles.container, loading && styles.disabled)} >
                        {
                            newUSerForm()?.map((field) => {
                                return (
                                    <div className={field.flex ? styles.item : styles.itemNoFlex} >
                                        <div className={styles.label} >
                                            <MDTypography variant="h6" color="dark">
                                                {field?.label}<span className={styles.required} >{field.required && " *"}</span>
                                            </MDTypography>
                                        </div>
                                        <div style={{ width: field.flex ? "67%" : "90%" }} >
                                            <FieldsGetter props={{
                                                ...field,
                                                formData,
                                                onChange,
                                                setFormData,
                                                width: '100%'
                                            }} />
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                    <Stack className={loading && styles.disabled} direction="row" spacing={1} style={{ margin: "10px 0 0 0" }} >
                        <Button loading={loading} type="primary" onClick={() => { submit() }} >Registar</Button>

                        <Button type="default" onClick={() => setOpen(false)} >Cancelar</Button>
                    </Stack>
                </MDBox>
            </Modal>
        </div>
    )
}
